/* ============================================================================
   FEATURED PRODUCTS PRO — FINAL JS (Dawn 15.4 Compatible)
   - Dynamic Price Update
   - Add-to-Cart (FormData)
============================================================================ */

(function () {
  if (window.__FPP_FINAL__) return;
  window.__FPP_FINAL__ = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* --------------------------
      SAFE ADD-TO-CART FUNCTION
  --------------------------- */
  async function fppAddToCart(variantId) {
    const cartDrawer = document.querySelector("cart-drawer");
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    
    // CRITICAL: Tells Shopify which page context we are in (Fixes Blank Drawer)
    formData.append("sections_url", window.location.pathname);

    // Collect required sections from Dawn's cart-drawer.js
    let sections = ["cart-drawer", "cart-icon-bubble"];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      sections = cartDrawer.getSectionsToRender().map((s) => s.id);
    }
    formData.append("sections", sections.join(","));

    // Use global route if available
    const fetchUrl = (window.routes && window.routes.cart_add_url) 
        ? window.routes.cart_add_url 
        : window.Shopify.routes.root + 'cart/add.js';

    const response = await fetch(fetchUrl, {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",  // Prevents redirect
        "Accept": "application/javascript"
      }
    });

    let parsedState;
    try {
      parsedState = await response.json();
    } catch (err) {
      console.error("Invalid JSON:", err);
      return;
    }

    // 422 Error Handling
    if (parsedState.status === 422) {
      alert("All available stock is already in your cart.");
      return;
    }

    /* -----------------------------------------------
       DRAWER UPDATE LOGIC
    ----------------------------------------------- */
    if (cartDrawer) {
        
        // 1. FORCE VISIBILITY: Remove 'is-empty' class immediately
        cartDrawer.classList.remove('is-empty'); 
        const drawerInner = cartDrawer.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');

        // 2. TRIGGER PUBSUB: Syncs with CartItems component
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'featured-products-pro', 
            cartData: parsedState,
            productVariantId: variantId
          });
        }

        // 3. RENDER CONTENT
        if (typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents(parsedState);
        } else {
           // Fallback
           if (parsedState.sections && parsedState.sections['cart-drawer']) {
              const doc = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
              const inner = doc.querySelector('#CartDrawer');
              if (inner && document.querySelector('#CartDrawer')) {
                 document.querySelector('#CartDrawer').innerHTML = inner.innerHTML;
              }
           }
        }

        // 4. OPEN DRAWER
        if (typeof cartDrawer.open === "function") {
            cartDrawer.open();
        } else {
            cartDrawer.classList.add('active', 'animate');
        }
    } else {
        window.location.href = '/cart';
    }
  }

  /* --------------------------
      BUY NOW FUNCTION
  --------------------------- */
  async function fppBuyNow(variantId) {
    try {
      // Clear previous items
      await fetch(window.Shopify.routes.root + "cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      });

      // Add selected variant
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      const fetchUrl = (window.routes && window.routes.cart_add_url) 
        ? window.routes.cart_add_url 
        : window.Shopify.routes.root + 'cart/add.js';

      await fetch(fetchUrl, {
        method: "POST",
        body: formData
      });

      window.location.href = "/checkout";
    } catch (err) {
      console.error("Buy Now error:", err);
      alert("Unable to start checkout. Please try again.");
    }
  }

  /* --------------------------
      CARD INITIALIZATION
  --------------------------- */
  function initCard(card) {
    if (!card || card.__fpp_init) return;
    card.__fpp_init = true;

    const hasSizes = card.dataset.hasSizes === "true";
    const defaultVariantId = card.dataset.defaultVariant;
    
    const addBtn = $(".fpp-add-btn", card);
    const buyBtn = $(".fpp-buy-btn", card);
    const sizeBtns = $$(".fpp-size-btn", card);
    const errorMsg = $(".fpp-error-msg", card);

    // Price Elements
    const currentPriceEl = $(".fpp-current-price", card);
    const oldPriceEl = $(".fpp-old-price", card);

    let selectedVariant = hasSizes ? null : defaultVariantId;

    // SIZE SELECTION CLICK
    sizeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.classList.contains("out-of-stock") || btn.disabled) return;

        // Deselect others in THIS card
        sizeBtns.forEach((b) => b.classList.remove("active"));
        
        // Select this one
        btn.classList.add("active");
        selectedVariant = btn.dataset.variantId;

        // --- UPDATE PRICE LOGIC START ---
        if (currentPriceEl && btn.dataset.price) {
          currentPriceEl.textContent = btn.dataset.price;
        }

        if (oldPriceEl) {
          if (btn.dataset.comparePrice) {
            oldPriceEl.textContent = btn.dataset.comparePrice;
            oldPriceEl.style.display = "inline";
          } else {
            oldPriceEl.style.display = "none";
          }
        }
        // --- UPDATE PRICE LOGIC END ---
        
        // Hide error
        if(errorMsg) errorMsg.style.display = 'none';
      });
    });

    // ADD TO CART CLICK
    if (addBtn) {
      addBtn.addEventListener("click", async () => {
        if (addBtn.disabled) return;

        if (hasSizes && !selectedVariant) {
          if(errorMsg) errorMsg.style.display = 'block';
          return;
        }

        const finalVariant = selectedVariant || defaultVariantId;
        const originalText = addBtn.textContent;

        addBtn.textContent = "Adding...";
        addBtn.disabled = true;

        await fppAddToCart(finalVariant);

        addBtn.textContent = originalText;
        addBtn.disabled = false;
      });
    }

    // BUY NOW CLICK
    if (buyBtn) {
      buyBtn.addEventListener("click", async () => {
        if (hasSizes && !selectedVariant) {
           if(errorMsg) errorMsg.style.display = 'block';
           return;
        }

        const finalVariant = selectedVariant || defaultVariantId;
        const originalText = buyBtn.textContent;

        buyBtn.textContent = "Processing...";
        buyBtn.disabled = true;

        await fppBuyNow(finalVariant);
        
        buyBtn.textContent = originalText;
        buyBtn.disabled = false;
      });
    }
  }

  /* --------------------------
      INIT
  --------------------------- */
  function initAll(root = document) {
    $$(".fpp-card", root).forEach(initCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else initAll();

  // Watch for new sections (e.g. infinite scroll or theme editor)
  new MutationObserver((mut) => {
    mut.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initAll(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();